import React, { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import ProductGrid from "./ProductGrid"; // Import ProductGrid
import products from "../data/products";
import ifus from "../data/ifuData";
import "../css/SearchPage.css";

const getSimilarity = (str1, str2) => {
    if (!str1 || !str2) return 0;
    str1 = str1.toLowerCase();
    str2 = str2.toLowerCase();

    const costs = new Array(str2.length + 1).fill(0).map((_, i) => i);
    for (let i = 1; i <= str1.length; i++) {
        let prevCost = i;
        for (let j = 1; j <= str2.length; j++) {
            const cost = str1[i - 1] === str2[j - 1] ? 0 : 1;
            const newCost = Math.min(costs[j] + 1, prevCost + 1, costs[j - 1] + cost);
            costs[j - 1] = prevCost;
            prevCost = newCost;
        }
        costs[str2.length] = prevCost;
    }
    return 1 - costs[str2.length] / Math.max(str1.length, str2.length);
};

const SearchPage = ({ onAddToCart }) => {
    const [searchParams] = useSearchParams();
    const query = searchParams.get("q") || "";
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [filteredIfus, setFilteredIfus] = useState([]);

    useEffect(() => {
        const threshold = 0.4; // Minimum similarity required

        // Filter products based on similarity
        const matchedProducts = products
            .map(product => ({
                ...product,
                similarity: getSimilarity(query, product.name)
            }))
            .filter(product => product.similarity >= threshold)
            .sort((a, b) => b.similarity - a.similarity);

        // Filter IFUs based on similarity
        const matchedIfus = ifus
            .map(ifu => ({
                ...ifu,
                similarity: getSimilarity(query, ifu.name)
            }))
            .filter(ifu => ifu.similarity >= threshold)
            .sort((a, b) => b.similarity - a.similarity);

        setFilteredProducts(matchedProducts);
        setFilteredIfus(matchedIfus);
    }, [query]);

    return (
        <div className="search-page">
            <div className="container">
                {/* Breadcrumbs */}
                <div className="breadcrumbs">
                    <Link to="/">Home</Link> &gt; Search Results
                </div>
                <h2>Your search for "{query}" revealed the following: </h2>
                <div className="green-bar-search"></div>
                {filteredProducts.length > 0 || filteredIfus.length > 0 ? (
                    <>
                        {filteredProducts.length > 0 && (
                            <>
                                <h3>Products</h3>
                                <ProductGrid products={filteredProducts} onAddToCart={onAddToCart} isSearchPage={true} />
                            </>
                        )}

                        {filteredIfus.length > 0 && (
                            <>
                                <h3>Instruction for Use (IFUs)</h3>
                                <ul className="ifu-list">
                                    {filteredIfus.map((ifu) => (
                                        <li key={ifu.id}>
                                            <Link to={`/ifu/${ifu.id}`}>📄 {ifu.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                            </>
                        )}
                    </>
                ) : (
                    <p>No close matches found.</p>
                )}
            </div>
        </div>

    );
};

export default SearchPage;
